"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isResultsTableColumnAdditionalProperty = exports.resultsTableColumnAdditionalPropertyDefinition = void 0;
exports.resultsTableColumnAdditionalPropertyDefinition = {
    view: { label: 'Results Table Column Additional' },
    constraints: [
        {
            name: 'orderedProperties',
            argument: [
                'results-table-column-name',
                'results-table-column-pinned',
                'results-table-column-title',
                'results-table-column-format-hint',
            ],
        },
    ],
    type: 'ordered-container',
    multiple: true,
    name: 'results-table-column-additional',
};
const isResultsTableColumnAdditionalProperty = (prop) => {
    return prop.name === exports.resultsTableColumnAdditionalPropertyDefinition.name;
};
exports.isResultsTableColumnAdditionalProperty = isResultsTableColumnAdditionalProperty;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicmVzdWx0cy10YWJsZS1jb2x1bW4tYWRkaXRpb25hbC5wcm9wZXJ0eS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9wcm9wZXJ0aWVzL3Jlc3VsdHMtdGFibGUtY29sdW1uLWFkZGl0aW9uYWwucHJvcGVydHkudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBRWEsUUFBQSw4Q0FBOEMsR0FBRztJQUM1RCxJQUFJLEVBQUUsRUFBRSxLQUFLLEVBQUUsaUNBQWlDLEVBQUU7SUFDbEQsV0FBVyxFQUFFO1FBQ1g7WUFDRSxJQUFJLEVBQUUsbUJBQW1CO1lBQ3pCLFFBQVEsRUFBRTtnQkFDUiwyQkFBMkI7Z0JBQzNCLDZCQUE2QjtnQkFDN0IsNEJBQTRCO2dCQUM1QixrQ0FBa0M7YUFDbkM7U0FDRjtLQUNGO0lBQ0QsSUFBSSxFQUFFLG1CQUFtQjtJQUN6QixRQUFRLEVBQUUsSUFBSTtJQUNkLElBQUksRUFBRSxpQ0FBaUM7Q0FDUixDQUFBO0FBSTFCLE1BQU0sc0NBQXNDLEdBQUcsQ0FBQyxJQUFrQixFQUFnRCxFQUFFO0lBQ3pILE9BQU8sSUFBSSxDQUFDLElBQUksS0FBSyxzREFBOEMsQ0FBQyxJQUFJLENBQUE7QUFDMUUsQ0FBQyxDQUFBO0FBRlksUUFBQSxzQ0FBc0MsMENBRWxEIn0=